import { render } from "./InitialPersonalDataForm.vue?vue&type=template&id=ea7cb254"
import script from "./InitialPersonalDataForm.vue?vue&type=script&lang=js"
export * from "./InitialPersonalDataForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__